import React, { useState } from 'react'
import { Upload, Button, Form, Tooltip } from 'antd'
import recycle from 'assets/images/icons/recycle.svg'
import file from 'assets/images/icons/file.svg'
import '../../../components/fileUpload/index.scss'
import '../index.scss'
import {MassTransferUploadIcon, TabsInfoIco, UploadIcon} from "../../../../modules/CustomIcons"
import { useTranslation } from 'react-i18next'

const MassFileUploadxls = (props: any) => {
    const {t} = useTranslation()
    return (
        <Form.Item
            name={props.name}
            label={props.labelItem}
            labelCol={props.labelCol}
            className={props.greenUpload ? `green-upload mass-transfer ${props.className}` : props.className}
            wrapperCol={props.wrapperCol}
            // className={props.className}
            rules={[{ required: props.required || false }]}
            style={props.style}


        >
            <Upload {...props.propsUpload} fileList={props.fileList} listType="picture" disabled ={props?.disabled ?? false}>
                {/* {console.log('file uploaded is' , props.fileList)} */}
                {props.fileList.length == 0 ? (
                    <Button className={props?.disabled ? 'disabled-uploadExcel-icon' : ''} style={{width: '100%',backgroundColor:'#f3f6fa'}}>
                        <div style={{display: 'flex',justifyContent:'flex-end',marginTop:"9px"}}> {props.placeholder} <div style={{marginBottom: '5px'}} > </div></div>
                    </Button>
                ) : <div className={'excell_upload'}>
                    <Button style={{width: '100%'}}  htmlType='button'>

                        <div className='flex'  style={{justifyContent: 'space-between', backgroundColor: '#fff'}}>
              <span
                  className='ant-upload-list-text ant-upload-list-text'>
                {props.fileList[0].name}
                </span>
                            <div style={{marginBottom: '5px'}} onClick={props.onRemove}> <img src={recycle} /></div>
                        </div>
                    </Button></div>}
                {!props.greenUpload ? (
                    <img src={file} className="file-img" />
                ) : props.fileList.length == 0 ? (
                    <button disabled={props.disabled}
                            className={`file-upload_btn mass-transfer-btn ${props.disabled ? 'disabled--btn' : 'blue--btn'}`}>
                        <MassTransferUploadIcon/>
                    </button>
                ) : (
                    <div />
                )}
            </Upload>
            {props.greenUpload && props.fileList.length !== 0 && (
                <button type='button' className="file-upload_btn mass-transfer-btn disabled--btn"><MassTransferUploadIcon/></button>
            )}
            {/* <Button icon={<AddIco />} */}
        </Form.Item>
    )
}

export default MassFileUploadxls
